module.exports = __webpack_public_path__ + "static/media/external-link.7133ff9c.svg";